import { render, staticRenderFns } from "./LayoutWallCenter.vue?vue&type=template&id=16f44d35"
import script from "./LayoutWallCenter.vue?vue&type=script&lang=js"
export * from "./LayoutWallCenter.vue?vue&type=script&lang=js"
import style0 from "./LayoutWallCenter.vue?vue&type=style&index=0&id=16f44d35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports